import { Injectable } from '@angular/core';

import { GetEnumValuesDto } from '../api/models';

@Injectable({
  providedIn: 'root',
})
export class TransferDataService {
  static id: any = '';
  static userName: any = '';

  static enumValues: GetEnumValuesDto[] = [];

  static selectedListPublic: any[] = [];
  static selectedListPersonal: any[] = [];
  static removedListPublic: any[] = [];
  static removedListPersonal: any[] = [];

  constructor() {}
}
